import { render, staticRenderFns } from "./ProductDetal.vue?vue&type=template&id=58fb0297&scoped=true&"
import script from "./ProductDetal.vue?vue&type=script&lang=js&"
export * from "./ProductDetal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetal.vue?vue&type=style&index=0&id=58fb0297&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb0297",
  null
  
)

export default component.exports